import React from "react";
import { Pencil, X } from "lucide-react";
import { useIntl } from "react-intl";
import { formatIndicatorLabel } from "../../../helpers/indicatorLabel";
import "./CurrentIndicators.sass";

const ACTION_ICON_SIZE = 14;

/**
 * The Current tab: the indicators of the chart in the order they were
 * added, in two columns (one on phones), "Name parameters", ✏️ that opens
 * its settings and ✕ that removes it. A hidden one is muted only on the chart.
 *
 * @param {object}   props
 * @param {object[]} props.indicators - engine.getIndicators() items
 * @param {(key: string) => void} props.onEdit
 * @param {(key: string) => void} props.onRemove
 */
const CurrentIndicators = ({ indicators, onEdit, onRemove }) => {
  const intl = useIntl();
  const editLabel = intl.formatMessage({ id: "futures.chart.indicators.settings" });
  const removeLabel = intl.formatMessage({ id: "futures.chart.indicators.remove" });

  return (
    <ul className="current-indicators">
      {indicators.map((indicator) => {
        const label = formatIndicatorLabel(indicator);

        return (
          <li key={indicator.key} className="current-indicators__item">
            <span className="current-indicators__label" title={label}>
              {label}
            </span>
            <button
              type="button"
              className="current-indicators__action"
              aria-label={`${editLabel} ${label}`}
              title={editLabel}
              onClick={() => onEdit(indicator.key)}
            >
              <Pencil size={ACTION_ICON_SIZE} aria-hidden="true" />
            </button>
            <button
              type="button"
              className="current-indicators__action"
              aria-label={`${removeLabel} ${label}`}
              title={removeLabel}
              onClick={() => onRemove(indicator.key)}
            >
              <X size={ACTION_ICON_SIZE} aria-hidden="true" />
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default CurrentIndicators;
